export enum Workflow {
  unified = 'unified',
  checklight = 'checklight',
}
